import { Currency } from '@/core/currency/interfaces';

const CRC: Currency = {
    name: 'Costa Rican Colon',
    demonym: 'Costa Rican',
    majorSingle: 'Colón',
    majorPlural: 'Colones',
    codeNumeric: '188',
    symbol: '₡',
    symbolNative: '₡',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CRC',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CRC;
